import Square from '../Square/Square';
import './JoinGrid.css'

const JoinGrid = ({R, S, rppR, rppS, currFilled, B, joinType}) => {

    const squares = {}
    const renderedSquares = []


    const getKey = (r, s, rr, ss) => {
        return `(${r},${s},${rr},${ss})`
    }

    let current;
    if (currFilled.length > 0) {
        current = currFilled.slice(-1)[0];
    } else {
        current = {cR: -1, cS: -1, cRR: -1, cSS: -1};
    }
    const currBlockMax = (Math.floor(current.cR / (B - 2)) + 1) * (B - 2);
    const currBlockMin = currBlockMax - (B-2);
    console.log(currBlockMax, currBlockMin);

    const setProperty = (r, s, rr, ss, prop, val) => {
        const sq = squares[getKey(r, s, rr, ss)];
        if (sq !== undefined && sq !== null) {
            squares[getKey(r, s, rr, ss)][prop] = val;
        }
    }

    for (let r = R-1; r >= 0; r -= 1) {
        for (let rr = rppR-1; rr >= 0; rr -= 1) {
            for (let s = 0; s < S; s++) {
                for (let ss = 0; ss < rppS; ss++) {
                    
                    squares[getKey(r,s,rr,ss)] = {r, s, rr, ss, curr: false, colored: false}
                }
            }
        }
    }
    for (let c of currFilled) {
        setProperty(c.cR, c.cS, c.cRR, c.cSS, 'colored', true);
    }
    setProperty(current.cR, current.cS, current.cRR, current.cSS, 'curr', true);

    // generate labels
    for (let r = R - 1; r >= 0; r -= 1) {
        for (let rr = rppR - 1; rr >= 0; rr -= 1) {
            for (let s = 0; s < S; s++) {
                for (let ss = 0; ss < rppS; ss++) {
                    if (s === 0 && ss === 0) {
                        renderedSquares.push(<div className={`horiz-head ${((joinType === 'BNLJ' && r >= currBlockMin && r < currBlockMax) || (joinType !== 'BNLJ' && r === current.cR)) ? 'curr-horiz' : ''}`}>page {r} record {rr}</div>)
                    }
                    const sq = squares[getKey(r, s, rr, ss)]
                    renderedSquares.push(<Square r={sq.r} s={sq.s} rr={sq.rr} ss={sq.ss} colored={sq.colored} curr={sq.curr}></Square>)
                }
            }
        }
    }
    renderedSquares.push(<div></div>)
    for (let s = 0; s < S; s++) {
        for (let ss = 0; ss < rppS; ss++) {
            renderedSquares.push(<div className={`vert-head ${(current.cS === s) ? 'curr-vert' : ''}`}>page {s} rec {ss}</div>)
        }
    }

    return (
        <div className="grid" style={{ gridTemplateRows: `repeat(${R * rppR}, 1fr) 8.5rem `, gridTemplateColumns: `8.5rem repeat(${S * rppS}, 1fr)`}}>
            {renderedSquares}
        </div>
    );
}

export default JoinGrid;
